/* CreationColor — menuknoppen rechts: 'Momenten & Thema's' (opent het uitklapmenu) en 'Spoed levering' (gewone link). Desktop.
   Meet daarnaast de zijmarges van de header (--ccx-gl / --ccx-gr), zodat alle uitklapmenu's op elke schermbreedte op de header uitlijnen. */
(function () {
  var done = false;
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z]/g, ''); }
  function desk() { return window.matchMedia('(min-width: 1025px)').matches; }

  /* uitklapmenu Momenten & Thema's opent alleen via een echte muisbeweging of klik, niet door een stilstaande cursor */
  try {
    var hs = document.createElement('style');
    hs.textContent = '@media (min-width:1025px){html body .ccx-inspiratie:not(.ccx-open):hover .ccx-inspiratie-mega{opacity:0!important;visibility:hidden!important;pointer-events:none!important;}}';
    document.head.appendChild(hs);
  } catch (e) {}
  var lx = -1, ly = -1, real = false;
  document.addEventListener('mousemove', function (e) { real = (e.screenX !== lx || e.screenY !== ly); lx = e.screenX; ly = e.screenY; }, true);

  /* linker- en rechterrand van de header-inhoud, relatief aan het vlak waarin de uitklapmenu's staan */
  function gutters() {
    try {
      var root = document.documentElement;
      if (!desk()) { root.style.removeProperty('--ccx-gl'); root.style.removeProperty('--ccx-gr'); return; }
      var mega = document.querySelector('.ccx-all-mega');
      var wrap = document.querySelector('.main-menu--wrapper');
      if (!mega || !wrap) return;
      var cart = document.querySelector('.header-single-line__item--cart');
      var ref = mega.offsetParent;
      var rl = 0, rr = root.clientWidth;
      if (ref && ref !== document.body && ref !== root) { var r = ref.getBoundingClientRect(); rl = r.left; rr = r.right; }
      var wb = wrap.getBoundingClientRect();
      var right = cart ? cart.getBoundingClientRect().right : wb.right;
      var gl = Math.round(wb.left - rl), gr = Math.round(rr - right);
      if (gl >= 16 && gl <= 400) root.style.setProperty('--ccx-gl', gl + 'px');
      if (gr >= 16 && gr <= 400) root.style.setProperty('--ccx-gr', gr + 'px');
      if (gl >= 16 && gl <= 400 && gr >= 16 && gr <= 400) { try { localStorage.setItem('ccxG:' + window.innerWidth, gl + ',' + gr); } catch (e2) {} }
    } catch (e) {}
  }

  /* rechterrand gelijk aan het winkelwagen-blok + hoogte gelijk aan de knop Alle producten;
     knoppen worden compacter en schuiven op als ze anders over zoek-/account-/winkelwagen-icoon heen vallen (sticky header) */
  function align(noGutters) {
    if (noGutters !== true) gutters();
    try {
      var pills = document.querySelector('.ccx-pills');
      if (!pills) return;
      var btn = document.querySelector('.ccx-all-cat-btn');
      [].slice.call(pills.querySelectorAll('.ccx-pill')).forEach(function (a) {
        a.style.removeProperty('height');
      });
      if (desk() && btn) {
        var h = btn.getBoundingClientRect().height;
        if (h > 20) {
          [].slice.call(pills.querySelectorAll('.ccx-pill')).forEach(function (a) {
            a.style.setProperty('height', h + 'px', 'important');
            a.style.setProperty('box-sizing', 'border-box', 'important');
          });
        }
      }
      var cart = document.querySelector('.header-single-line__item--cart');
      if (!cart) return;
      pills.style.transform = '';
      pills.classList.remove('ccx-compact', 'ccx-compact2');
      if (!desk()) return;
      var place = function () {
        pills.style.transform = '';
        var d = cart.getBoundingClientRect().right - pills.getBoundingClientRect().right;
        if (Math.abs(d) > 0.5 && Math.abs(d) < 200) pills.style.transform = 'translateX(' + d + 'px)';
      };
      var overlap = function () {
        var pr = pills.getBoundingClientRect(), minL = 1e9;
        [].slice.call(document.querySelectorAll('.header-single-line__item, [class*="search"] svg, [class*="search"] img, .header__search')).forEach(function (e) {
          if (e.closest('.ccx-pills, .ccx-all-mega, .ccx-inspiratie-mega')) return;
          var r = e.getBoundingClientRect();
          if (r.width < 4 || r.height < 4) return;
          if (r.bottom < pr.top || r.top > pr.bottom) return;
          if (r.left < pr.left + 40) return;
          if (r.left < minL) minL = r.left;
        });
        return minL === 1e9 ? 0 : pr.right - minL + 12;
      };
      place();
      if (overlap() > 0) { pills.classList.add('ccx-compact'); place(); }
      if (overlap() > 0) { pills.classList.add('ccx-compact2'); place(); }
      var o = overlap();
      if (o > 0) {
        var t = pills.style.transform, cur = t ? parseFloat(t.replace(/[^-0-9.]/g, '')) : 0;
        pills.style.transform = 'translateX(' + (cur - o) + 'px)';
      }
    } catch (e) {}
  }
  var rt, st;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(align, 120); });
  window.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { align(true); }, 80); }, { passive: true });
  window.addEventListener('load', function () { align(); setTimeout(align, 500); setTimeout(align, 1500); });
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { align(); }); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', gutters); } else { gutters(); }

  function init() {
    if (done) return;
    try {
      var insp = document.querySelector('.ccx-inspiratie');
      if (!insp) return;
      var wrap = insp.parentNode;
      var mega = insp.querySelector('.ccx-inspiratie-mega');
      var menu = wrap.querySelector('.header__inline-menu') || wrap;
      var timer;
      var all = [].slice.call(menu.querySelectorAll('a')).filter(function (a) { return !a.closest('.ccx-nav-item'); });
      function find(k) { return all.filter(function (a) { return norm(a.textContent) === k; })[0]; }
      var mo = find('momenten'), th = find('themas'), sp = find('spoedlevering');
      if (!mo && !th && !sp) return;
      done = true;
      var pills = document.createElement('div');
      pills.className = 'ccx-pills';

      /* Spoed levering: knop met klok-icoon, gewone link */
      if (sp) {
        var spLi = sp.closest('li');
        sp.classList.add('ccx-pill');
        sp.setAttribute('data-ccx-pill', 'spoed');
        pills.appendChild(sp);
        if (spLi) spLi.classList.add('ccx-pill-hidden');
      }

      /* Momenten & Thema's: 1 knop, opent het uitklapmenu */
      var panel = mo || th;
      var key = mo ? 'momenten' : 'themas';
      if (panel) {
        var pLi = panel.closest('li');
        panel.classList.add('ccx-pill');
        panel.setAttribute('data-ccx-pill', 'momenten');
        panel.setAttribute('data-ccx-key', key);
        panel.setAttribute('aria-haspopup', 'true');
        panel.setAttribute('aria-expanded', 'false');
        var label = panel.querySelector('.text') || panel;
        label.textContent = 'Momenten & Thema’s';
        pills.appendChild(panel);
        if (pLi) pLi.classList.add('ccx-pill-hidden');
        if (mo && th) { var thLi = th.closest('li'); if (thLi) thLi.classList.add('ccx-pill-hidden'); th.classList.add('ccx-pill-hidden'); }
      }
      wrap.appendChild(pills);
      wrap.classList.add('ccx-ready');
      align();
      if (!panel) return;

      function setTab(k) {
        [].slice.call(insp.querySelectorAll('.ccx-insp-tab')).forEach(function (t) {
          if (norm(t.textContent).indexOf(k) === 0 && !t.classList.contains('ccx-active')) {
            t.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
            t.click();
          }
        });
      }
      function mark(on) {
        panel.classList.toggle('is-open', on);
        panel.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      function open() {
        clearTimeout(timer);
        var a = document.querySelector('.ccx-all-categories');
        if (a) a.classList.remove('ccx-open');
        setTab(key);
        insp.classList.add('ccx-open');
        mark(true);
      }
      function close() { clearTimeout(timer); insp.classList.remove('ccx-open'); mark(false); }
      function closeSoon() { clearTimeout(timer); timer = setTimeout(close, 250); }
      panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
      panel.addEventListener('mousemove', function () { if (desk() && real && !insp.classList.contains('ccx-open')) open(); });
      panel.addEventListener('mouseleave', function () { if (desk()) closeSoon(); });
      panel.addEventListener('click', function (e) { if (desk()) { e.preventDefault(); e.stopPropagation(); open(); } });
      if (mega) {
        mega.addEventListener('mouseenter', function () { clearTimeout(timer); });
        mega.addEventListener('mouseleave', closeSoon);
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.ccx-pill') && !e.target.closest('.ccx-inspiratie-mega')) close();
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  window.addEventListener('load', init);
  setTimeout(init, 600);
  setTimeout(init, 1800);
})();
